/**
 * Human-friendly archive URLs: /family/:slug, /person/:slug when slugs exist; UUID paths otherwise.
 */

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuid(value) {
  return typeof value === 'string' && UUID_RE.test(value.trim());
}

/** Tree dashboard / tree view link */
export function treeHref(tree) {
  if (!tree?.id) return '/dashboard';
  if (tree.slug) return `/family/${tree.slug}`;
  return `/tree/${tree.id}`;
}

/** Person legacy page link */
export function personHref(person) {
  if (!person?.id) return '/dashboard';
  if (person.slug) return `/person/${person.slug}`;
  return `/person/${person.id}`;
}

/** Legacy Book web preview for one person */
export function legacyBookPreviewHrefFromPerson(person) {
  if (!person?.id) return '/dashboard';
  if (person.slug) return `/person/${person.slug}/legacy-book`;
  return `/person/${person.id}/legacy-book`;
}
